import { useSearchParams } from "react-router-dom";
import { useState } from "react";
import { StartForgotPassword } from "@features/Auth/StartForgotPassword";
import { ConfirmForgotPassword } from "@features/Auth/ConfirmForgotPassword";
import { PageContainer } from "./styles";
import { RootLayout } from "@shared/layouts/RootLayout";
import { Helmet } from "react-helmet-async";
import { useAppName } from "@shared/hooks/useAppName";

export const ForgotPassword = () => {
  const [searchParams] = useSearchParams();
  const [emailResetPassword, setEmailResetPassword] = useState("");
  const defaultEmail = searchParams.get("email");
  const appName = useAppName();

  const head = (
    <Helmet>
      <title>Forgot Password - {appName}</title>
      <meta
        name="description"
        content="Forgot your password? Reset it here to regain access to your account."
      />
    </Helmet>
  );

  if (emailResetPassword) {
    return (
      <RootLayout theme="light">
        {head}
        <PageContainer>
          <ConfirmForgotPassword email={emailResetPassword} />
        </PageContainer>
      </RootLayout>
    );
  }

  return (
    <RootLayout theme="light">
      {head}
      <PageContainer>
        <StartForgotPassword
          email={defaultEmail}
          setEmailResetPassword={setEmailResetPassword}
        />
      </PageContainer>
    </RootLayout>
  );
};
